export function getAll() {
  return [
    {
      value: 5,
      name: "5 minutes",
      text: `5分鐘`,
    },
    {
      value: 10,
      name: "10 minutes",
      text: `10分鐘`,
    },
    {
      value: 15,
      name: "15 minutes",
      text: `15分鐘`,
    },
    {
      value: 20,
      name: "20 minutes",
      text: `20分鐘`,
    },
    {
      value: 30,
      name: "30 minutes",
      text: `30分鐘`,
    },
    {
      value: 60,
      name: "60 minutes",
      text: `1小時`,
    },
    {
      value: 0,
      name: "Customize",
      text: `自訂`,
    },
  ];
}
